import { render, staticRenderFns } from "./EcommerceLeftMenu.vue?vue&type=template&id=38fbbd28&"
import script from "./EcommerceLeftMenu.vue?vue&type=script&lang=js&"
export * from "./EcommerceLeftMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports